<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<style lang="scss">
body {
  font-family: $font-family;
}
</style>
